import { put, call, select, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import { push } from 'connected-react-router';
import ApiService from '../Services/ApiService';
import AppActions from '../Stores/App/Actions';
import PutAwaySync01Actions, { PutAwaySync01Types } from '../Stores/PutAwaySync01/Actions';

const getAppStore = state => state.app;

export function* putAwaySync01FetchPutAwaySync01({ currentPage, sorts, filters, pageSize }) {
  try {
    yield put(PutAwaySync01Actions.putAwaySync01FetchPutAwaySync01Loading(true));

    const processedSorts = [];
    Object.entries(sorts).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      processedSorts.push(`${key}:${value === 'ascend' ? 'ASC' : 'DESC'}`);
    });

    const processedFilters = [];
    Object.entries(filters).forEach(entry => {
      const key = entry[0];
      const value = entry[1];
      if (value) {
        processedFilters.push(`${key}:${value}`);
      }
    });

    const app = yield select(getAppStore);
    const getData = {
      page: currentPage,
      sorts: processedSorts,
      filters: processedFilters,
      pageSize
    };

    const result = yield call(
      ApiService.getApi, // function
      app.apiUrl,
      `putAway/indexProcess/PUT_AWAY_SYNC_01/${app.curSiteFlowId}`,
      app.token,
      getData,
      'multipart/form-data' // params
    );

    if (result.isSuccess === true) {
      // if nowCurrentPage is more than lastPage, then nowCurrentPage = lastPage
      let nowCurrentPage = result.data.current_page;
      if (nowCurrentPage > result.data.last_page) {
        nowCurrentPage = result.data.last_page;
      }

      yield put(
        PutAwaySync01Actions.putAwaySync01FetchPutAwaySync01Success(
          result.data.data,
          nowCurrentPage,
          result.data.last_page,
          result.data.total,
          result.data.per_page
        )
      );
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwaySync01Actions.putAwaySync01FetchPutAwaySync01Loading(false));
  }
}

export function* putAwaySync01GoToDocument({ hdrId }) {
  const app = yield select(getAppStore);
  yield put(push(`${app.appPath}/putAwayDetail/update/${hdrId}`));
}

export function* putAwaySync01SyncNow({ hdrIds }) {
  try {
    yield put(PutAwaySync01Actions.putAwaySync01SyncLoading(true));

    const app = yield select(getAppStore);
    const postData = {
      siteFlowId: app.curSiteFlowId,
      hdrIds
    };

    const result = yield call(
      ApiService.postApi, // function
      app.apiUrl,
      `putAway/syncProcess/PUT_AWAY_SYNC_01`,
      app.token,
      postData
    );

    if (result.isSuccess === true) {
      yield put(PutAwaySync01Actions.putAwaySync01SyncNowSuccess());

      yield call(notification.success, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_SUCCESS_MESSAGE_DURATION, 10)
      });
    } else if (result.isTokenExpired === true) {
      yield put(AppActions.appTokenExpired(result.message));
    } else if (result.isPasswordExpired === true) {
      yield put(AppActions.appPasswordExpired(result.message));
    } else {
      yield call(notification.error, {
        message: result.message,
        duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
      });
    }
  } catch (error) {
    yield call(notification.error, {
      message: error.message,
      duration: parseInt(process.env.REACT_APP_ERROR_MESSAGE_DURATION, 10)
    });
  } finally {
    yield put(PutAwaySync01Actions.putAwaySync01SyncLoading(false));
  }
}

export const saga = [
  takeLatest(PutAwaySync01Types.PUT_AWAY_SYNC01_GO_TO_DOCUMENT, putAwaySync01GoToDocument),
  takeLatest(
    PutAwaySync01Types.PUT_AWAY_SYNC01_FETCH_PUT_AWAY_SYNC01,
    putAwaySync01FetchPutAwaySync01
  ),
  takeLatest(PutAwaySync01Types.PUT_AWAY_SYNC01_SYNC_NOW, putAwaySync01SyncNow)
];
